import './answer-form.less';
import PropTypes from 'prop-types';
import React from 'react';
import { Field, reduxForm } from 'redux-form';
import cn from 'classname';

import TextField from '../../shared/form-elements/textarea';
import Attachment from '../../shared/form-elements/attachment';

const AnswerForm = ({
	isEditMode,
	submitEdit,
	submitAnswer,
	isClosed,
	preparationFile,
	attachmentsInfo,
	removeFile,
	handleSubmit,
	intl
}) => (
	<form
		className="ui-form answer-form"
		onKeyDown={e => handleKeyDown(e, handleSubmit(data => (isEditMode ? submitEdit(data) : submitAnswer(data))))}
		onSubmit={handleSubmit(data => (isEditMode ? submitEdit(data) : submitAnswer(data)))}
	>
		<div className="ui-form__element">
			<Field name="text" placeholder="Answer" component={TextField} disabled={isClosed} showLabel={false} />
		</div>
		<div className="ui-form__element control-wrap">
			<button
				type="submit"
				disabled={isClosed}
				className={cn({
					'ui-btn': true,
					'ui-btn-primary': !isClosed
				})}
			>
				{!isEditMode ? intl('Send answer') : intl('Edit post')}
			</button>

			<div className="attachment">
				<Field
					name="files"
					component={Attachment}
					placeholder={intl('Attach files')}
					preparationFile={preparationFile}
				/>

				<div className="attachment__list">
					{attachmentsInfo &&
						attachmentsInfo.map((fileName, index) => (
							<p key={index} className="file-info">
								{fileName}
								<span
									className="icon-delete"
									onClick={e => {
										confirm(intl('Remove attachment?')) && removeFile(index);
									}}
								/>
							</p>
						))}
				</div>
			</div>
		</div>
	</form>
);

AnswerForm.propTypes = {
	handleSubmit: PropTypes.func,
	submitAnswer: PropTypes.func,
	submitEdit: PropTypes.func,
	intl: PropTypes.func,
	preparationFile: PropTypes.func,
	removeFile: PropTypes.func,
	isClosed: PropTypes.bool,
	isEditMode: PropTypes.bool,
	attachmentsInfo: PropTypes.array
};

const Form = ({
	handleSubmit,
	submitAnswer,
	submitEdit,
	isClosed,
	isEditMode,
	intl,
	preparationFile,
	attachmentsInfo,
	removeFile
}) => (
	<div
		className="support__answers-form"
		style={{ flexBasis: `${attachmentsInfo.length * 10 + 235}px` }} >
		<AnswerForm
			handleSubmit={handleSubmit}
			isEditMode={isEditMode}
			submitEdit={submitEdit}
			submitAnswer={submitAnswer}
			isClosed={isClosed}
			preparationFile={preparationFile}
			attachmentsInfo={attachmentsInfo}
			removeFile={removeFile}
			intl={intl}
		/>
	</div>
);

const handleKeyDown = (e, cb) => {
	if (e.key === 'Enter' && e.ctrlKey) {
		e.preventDefault();
		cb();
	}
};

Form.propTypes = {
	handleSubmit: PropTypes.func,
	submitAnswer: PropTypes.func,
	submitEdit: PropTypes.func,
	intl: PropTypes.func,
	preparationFile: PropTypes.func,
	removeFile: PropTypes.func,
	isClosed: PropTypes.bool,
	isEditMode: PropTypes.bool,
	attachmentsInfo: PropTypes.array
};

export default reduxForm({
	form: 'supportForm'
})(Form);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/threads/components/answer-form.js